import type { MediaManifest, MediaManifestResponse } from "../../domain/contracts";
import { fetchJson, fetchProtectedAsset } from "../apiClient";
import { frontendEnv } from "../env";

type MediaEvidenceRef = {
  assetId: string;
  mediaType: string;
};

const mediaManifestCache = new Map<string, Promise<MediaManifest>>();

function manifestCacheKey(assetId: string, mediaType: string): string {
  return `${assetId}:${mediaType}`;
}

export function fetchMediaManifest(assetId: string, mediaType: string): Promise<MediaManifest> {
  const cacheKey = manifestCacheKey(assetId, mediaType);
  const cachedManifest = mediaManifestCache.get(cacheKey);
  if (cachedManifest) {
    return cachedManifest;
  }

  const manifestRequest = fetchJson<MediaManifestResponse>(
    `${frontendEnv.publicApiBaseUrl}/api/media/${encodeURIComponent(assetId)}/manifest?mediaType=${encodeURIComponent(mediaType)}`,
  ).then((response) => response.manifest);

  mediaManifestCache.set(cacheKey, manifestRequest);
  return manifestRequest;
}

export async function fetchMediaObjectUrlForEvidence(item: MediaEvidenceRef): Promise<string> {
  const manifest = await fetchMediaManifest(item.assetId, item.mediaType);
  const mediaPath = manifest.variants[manifest.defaultVariant];
  const assetUrl = new URL(mediaPath, frontendEnv.publicMediaBaseUrl).toString();
  const blob = await fetchProtectedAsset(assetUrl);
  return URL.createObjectURL(blob);
}

export async function fetchMediaBlobForEvidence(item: MediaEvidenceRef): Promise<Blob> {
  const manifest = await fetchMediaManifest(item.assetId, item.mediaType);
  const mediaPath = manifest.variants[manifest.defaultVariant];
  const assetUrl = new URL(mediaPath, frontendEnv.publicMediaBaseUrl).toString();
  return fetchProtectedAsset(assetUrl);
}
